let current_direction = '';
// Retain scroll position of groups screen
let current_groups_scroll_top = 0;

let lastClickTime = Date.now();

function preventMultipleTaps() {
	let secondClick = Date.now();
	if (Math.abs(secondClick - lastClickTime) > 1200) {
		lastClickTime = Date.now();
		return true;
	} else {
		return false;
	}
}

export function navigateLayout(direction) {
	if (!preventMultipleTaps()) return;

	window.app.showLoading();
	current_direction = direction;
	window.app.receiver.next_component = 'Layout';
	window.app.receiver.getGroups();
}

export function navigateRTEnergy(direction) {
	if (!preventMultipleTaps()) return;

	window.app.showLoading();
	current_direction = direction;
	window.app.receiver.next_component = 'RT_Energy_View';
	window.app.receiver.readJSONFile({ name: 'RT_Energy_Layout.json' })
}

export function navigateIAQMonitoring(direction) {
	if (!preventMultipleTaps()) return;

	window.app.showLoading();
	current_direction = direction;
	window.app.receiver.next_component = 'IAQ_Monitoring';
	window.app.receiver.readJSONFile({ name: 'iaq_monitoring_settings.json' })
}

export function navigateDashboard(direction) {
	if (!preventMultipleTaps()) return;

	window.app.showLoading();
	if (window.app.state.is_msm_mode) {
		window.app.receiver.next_component = 'MSM';
		window.app.receiver.getMSMSiteList();
	} else {
		current_direction = direction;
		window.app.receiver.next_component = 'Dashboard_With_Swipe';
		window.app.receiver.getGroups();
	}
}

export function redirectToDashboardScreen(groups) {
	window.app.hideLoading();
	switch (current_direction) {
		case 'Left':
			window.app.content_area.current.content_handler('Dashboard', groups);
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInRight2');
			break;
		case 'Right':
			window.app.content_area.current.content_handler('Dashboard', groups);
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInLeft');
			break;
		default:
			window.app.content_area.current.content_handler('Dashboard', groups);
			break;
	}
}

export function navigateGroups(direction, groups_scroll_top) {
	if (!preventMultipleTaps()) return;

	if (groups_scroll_top != null && groups_scroll_top != undefined) current_groups_scroll_top = groups_scroll_top;
	window.app.showLoading();
	current_direction = direction;
	window.app.receiver.getGroups();
}

export function redirectToGroupScreen(groups) {
	window.app.hideLoading();
	switch (current_direction) {
		case 'Left':
			window.app.content_area.current.content_handler('Groups', { groups: groups, groups_scroll_top: current_groups_scroll_top });
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInRight2');
			break;
		case 'Right':
			window.app.content_area.current.content_handler('Groups', { groups: groups, groups_scroll_top: current_groups_scroll_top });
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInLeft');
			break;
		default:
			window.app.content_area.current.content_handler('Groups', { groups: groups, groups_scroll_top: current_groups_scroll_top });
			break;
	}
	current_groups_scroll_top = 0;
}

export function navigateScenes(direction) {
	if (!preventMultipleTaps()) return;

	window.app.showLoading();
	window.app.receiver.stored_params.from = "Scenes";
	window.app.receiver.next_component = 'Scenes';
	current_direction = direction;
	window.app.receiver.getScene();
}

export function redirectToScenesScreen(scenes) {
	window.app.hideLoading();
	switch (current_direction) {
		case 'Left':
			window.app.content_area.current.content_handler('Scenes', { scenes: scenes });
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInRight2');
			break;
		case 'Right':
			window.app.content_area.current.content_handler('Scenes', { scenes: scenes });
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInLeft');
			break;
		default:
			window.app.content_area.current.content_handler('Scenes', { scenes: scenes });
			break;
	}
}

export function navigateReport(direction) {
	if (!preventMultipleTaps()) return;

	//Get report settings before navigate to reports
	window.app.showLoading();
	current_direction = direction;
	window.app.receiver.next_component = 'Reports';
	window.app.receiver.loadReportSettings();
}

export function redirectToReportScreen(report_settings) {
	window.app.hideLoading();
	switch (current_direction) {
		case 'Left':
			window.app.content_area.current.content_handler('Reports', { report_settings: report_settings });
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInRight2');
			break;
		case 'Right':
			window.app.content_area.current.content_handler('Reports', { report_settings: report_settings });
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInLeft');
			break;
		default:
			window.app.content_area.current.content_handler('Reports', { report_settings: report_settings });
			break;
	}
}

export function navigateSystem(direction) {
	if (!preventMultipleTaps()) return;

	switch (direction) {
		case 'Left':
			window.app.content_area.current.content_handler('System', {});
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInRight2');
			break;
		case 'Right':
			window.app.content_area.current.content_handler('System', {});
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInLeft');
			break;
		default:
			window.app.content_area.current.content_handler('System', {});
			break;
	}
}

export function navigateGuestRoom(direction) {
	if (!preventMultipleTaps()) return;
	
	window.app.showLoading();
	current_direction = direction;
	window.app.receiver.next_component = 'Guest_Room_Overview';
	window.app.receiver.getGuestRooms();
}

export function redirectToGuestRoomScreen(param) {
	window.app.hideLoading();
	switch (current_direction) {
		case 'Left':
			window.app.content_area.current.content_handler('Guest_Room_Overview', param);
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInRight2');
			break;
		case 'Right':
			window.app.content_area.current.content_handler('Guest_Room_Overview', param);
			window.app.content_area.current.switch_content.current.handleScreenAnimation('slideInLeft');
			break;
		default:
			window.app.content_area.current.content_handler('Guest_Room_Overview', param);
			break;
	}
}

